import { AxiosResponse } from 'axios';
import { IGridStateSettings } from '@models/response/IGridStateSettings';

export abstract class IDataGridStateService {
    abstract fetchState(data: any): Promise<AxiosResponse<IGridStateSettings[]>>;
    abstract saveState(stateKey: string, settings: IGridStateSettings[]): Promise<AxiosResponse<any>>;
}
